import { formatDate } from '@thoughtspot/date-format-util';
import { translate as t } from '@thoughtspot/i18n';
import { formatCompactScientificNumber } from '@thoughtspot/number-format-util';
const DATE_FORMAT_STRING = 'EEEE, d MMMM yyyy, t ZZZZ';
export const dataColumnsClusterDetails = [
    {
        id: 'property',
        headerName: t('adminUI.captions.PROPERTY'),
        minWidth: 80,
        maxWidth: 240,
    },
    {
        id: 'content',
        headerName: t('adminUI.captions.CONTENT'),
        minWidth: 100,
        maxWidth: 240,
    },
];
export const prepareTableRowDataClusterDetails = (statsData, clusterInfoData) => {
    const DATE_FORMAT_STRING = 'EEEE, d MMMM yyyy, t ZZZZ';
    const hdfsNameNodes = statsData.config.hdfs.default_cluster.name_node.map((nameNode) => {
        return `${nameNode.host}:${nameNode.port}`;
    });
    const zookeeperNodes = statsData.config.zoo_server.map((zooServer) => {
        return `${zooServer.host}:${zooServer.port}`;
    });
    const lastUpdateTime = statsData.last_update_time_since_epoch
        ? formatDate(statsData.last_update_time_since_epoch * 1000, DATE_FORMAT_STRING)
        : t('adminUI.messages.NOT_AVAILABLE_MESSAGE');
    return [
        {
            property: t('adminUI.captions.CLOUD_PROVIDER'),
            content: clusterInfoData.cloudProvider ||
                t('adminUI.messages.NOT_AVAILABLE_MESSAGE'),
        },
        {
            property: t('adminUI.captions.CLUSTER_ALERT_EMAIL'),
            content: statsData.monitoring.config.cluster_alert_email ||
                t('adminUI.messages.NOT_AVAILABLE_MESSAGE'),
        },
        {
            property: t('adminUI.captions.CLUSTER_ID'),
            content: statsData.cluster_id ||
                t('adminUI.messages.NOT_AVAILABLE_MESSAGE'),
        },
        {
            property: t('adminUI.captions.CLUSTER_NAME'),
            content: statsData.cluster_name ||
                t('adminUI.messages.NOT_AVAILABLE_MESSAGE'),
        },
        {
            property: t('adminUI.captions.HDFS_NAME_NODES'),
            content: hdfsNameNodes || t('adminUI.messages.NOT_AVAILABLE_MESSAGE'),
        },
        {
            property: t('adminUI.captions.LAST_UPDATE_TIME'),
            content: lastUpdateTime,
        },
        {
            property: t('adminUI.captions.PERIODIC_SNAPSHOT_MODE'),
            content: statsData.periodic_snapshot?.enabled
                ? t('adminUI.messages.PERIODIC_SNAPSHOT_ENABLED')
                : t('adminUI.messages.NOT_AVAILABLE_MESSAGE'),
        },
        {
            property: t('adminUI.captions.PERSISTENT_STORAGE'),
            content: clusterInfoData.persistentStorage,
        },
        {
            property: t('adminUI.captions.RELEASE'),
            content: statsData.release_name ||
                t('adminUI.messages.NOT_AVAILABLE_MESSAGE'),
        },
        {
            property: t('adminUI.captions.ZOOKEEPER_SERVERS'),
            content: zookeeperNodes || t('adminUI.messages.NOT_AVAILABLE_MESSAGE'),
        },
    ];
};
export const dataColumnsClusterLogs = [
    {
        id: 'time',
        headerName: t('adminUI.captions.EVENT_TIMESTAMP'),
        minWidth: 280,
        maxWidth: 280,
    },
    {
        id: 'type',
        headerName: t('adminUI.captions.EVENT_TYPE'),
        minWidth: 40,
        maxWidth: 240,
    },
    {
        id: 'release',
        headerName: t('adminUI.captions.EVENT_RELEASE'),
        minWidth: 100,
        maxWidth: 240,
    },
];
export const prepareClusterLogsData = (logEvents) => {
    return logEvents.log.event
        .filter(event => event.type === 'INSTALL' ||
        event.type === 'UPDATE' ||
        event.type === 'UPDATE_END')
        .map(event => {
        const time = formatDate(event.timestamp_seconds * 1000, DATE_FORMAT_STRING);
        const type = event.type;
        let release = t('adminUI.messages.NOT_AVAILABLE_MESSAGE');
        const releaseAttribute = event.attribute?.find((attr) => attr.key === 'release');
        release = releaseAttribute ? releaseAttribute.value : release;
        return {
            time,
            type,
            release,
        };
    });
};
export const dataColumnsClusterSnapshots = [
    {
        id: 'endTime',
        headerName: t('adminUI.captions.SNAPSHOT_FINISH_TIME'),
        minWidth: 260,
        maxWidth: 260,
    },
    {
        id: 'name',
        headerName: t('adminUI.captions.SNAPSHOT_NAME'),
        minWidth: 260,
        maxWidth: 260,
    },
    {
        id: 'reason',
        headerName: t('adminUI.captions.SNAPSHOT_REASON'),
        minWidth: 360,
        maxWidth: 360,
    },
    {
        id: 'size',
        headerName: t('adminUI.captions.SNAPSHOT_SIZE'),
        minWidth: 100,
        maxWidth: 240,
    },
];
export const prepareClusterSnapshotsData = (listSnapshotData) => {
    if (!Array.isArray(listSnapshotData.periodic_snapshot))
        return [];
    return listSnapshotData.periodic_snapshot.map(snapshot => {
        const endTime = formatDate(snapshot.finish_timestamp_seconds * 1000, DATE_FORMAT_STRING);
        const name = snapshot.name;
        const reason = snapshot.reason;
        const size = snapshot.size_bytes
            ? formatCompactScientificNumber(snapshot.size_bytes)
            : '';
        return {
            endTime,
            name,
            reason,
            size,
        };
    });
};
//# sourceMappingURL=cluster-status-utils.js.map